import _parseInt from 'lodash/parseInt';
import _toFinite from 'lodash/toFinite';
import mParking from '../../../models/cpm/parking';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_LIST_MY_CARPARK_BOOKING_OPTIONS,
  CPM_GET_MY_BOOKINGS_LIST,
  CPM_GET_MY_BOOKING,
  CPM_GET_UPDATED_MY_BOOKING,
  CPM_CANCEL_MY_BOOKING,
  CPM_BOOK_CARPARK,
  CPM_EXTEND_BOOK_CARPARK,
  CPM_PAY_BOOKING_OVERSTAY,
  CPM_DOWNLOAD_MY_INVOICE,
  CPM_RESET_MY_INVOICE_DOWNLOAD_REQUEST,
  CPM_GET_OFFER,
  CPM_SEARCH_CARPARK_BOOKING_OFFER,
  CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER,
  CPM_DECLARE_FINAL_EXIT_FOR_BOOKING,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import {
  deserializeBooking, deserializeExtendBooking, deserializePayBookingOverstay, deserializeBookingOption,
} from '../../../models/cpm/booking';
import { getBookingLastOverstayPurchase, deserializeOffer } from '../../../models/cpm/finance';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmBooking;
const cpmBooking = (state = initialSettings, action) => {
  let mutationResult;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'cpmBooking') {
        return {
          ...state,
          list: { ...initialSettings.list },
          listMyBookingOptions: { ...initialSettings.listMyBookingOptions },
          book: { ...initialSettings.book },
          cancel: { ...initialSettings.cancel },
          downloadMyInvoice: { ...initialSettings.downloadMyInvoice },
          declareFinalExit: { ...initialSettings.declareFinalExit },
          offer: { ...initialSettings.offer },
          search: { ...initialSettings.search },
          searchBookingExtensionOffer: { ...initialSettings.searchBookingExtensionOffer },
        };
      }
      if (action.target === 'myBooking') {
        return {
          ...state,
          myBooking: { ...initialSettings.myBooking },
        };
      }
      if (action.target === 'cancel') {
        return {
          ...state,
          cancel: { ...initialSettings.cancel },
        };
      }
      return state;
    // LIST MY BOOKINGS
    case CPM_GET_MY_BOOKINGS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_MY_BOOKINGS_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_MY_BOOKINGS_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserializeBooking(action.data.listMyBookings.entries),
            pageNumber: _parseInt(action.data.listMyBookings.pageNumber),
            pageSize: _parseInt(action.data.listMyBookings.pageSize),
            totalEntries: _parseInt(action.data.listMyBookings.totalEntries),
            totalPages: _parseInt(action.data.listMyBookings.totalPages),
          },
        },
      };
    // LIST MY BOOKING OPTIONS
    case CPM_LIST_MY_CARPARK_BOOKING_OPTIONS:
      return {
        ...state,
        listMyBookingOptions: {
          ...state.listMyBookingOptions,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_LIST_MY_CARPARK_BOOKING_OPTIONS}_ERROR`:
      return {
        ...state,
        listMyBookingOptions: {
          ...state.listMyBookingOptions,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_LIST_MY_CARPARK_BOOKING_OPTIONS}_SUCCESS`:
      return {
        ...state,
        listMyBookingOptions: {
          ...state.listMyBookingOptions,
          loading: false,
          result: deserializeBookingOption(action.data.listMyBookingOptions),
        },
      };
    // BOOK
    case CPM_BOOK_CARPARK:
      return {
        ...state,
        book: {
          ...state.book,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_BOOK_CARPARK}_ERROR`:
      return {
        ...state,
        book: {
          ...state.book,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_BOOK_CARPARK}_SUCCESS`:
      return {
        ...state,
        book: {
          ...state.book,
          loading: false,
          result: deserializeBooking(action.data.book),
        },
      };
    // EXTEND BOOKING
    case CPM_EXTEND_BOOK_CARPARK:
      return {
        ...state,
        book: {
          ...state.book,
          error: null,
          loading: true,
          result: null,
        },
      };

    case `${CPM_EXTEND_BOOK_CARPARK}_ERROR`:
      return {
        ...state,
        book: {
          ...state.book,
          error: action.error,
          loading: false,
        },
      };

    case `${CPM_EXTEND_BOOK_CARPARK}_SUCCESS`:
      return {
        ...state,
        book: {
          ...state.book,
          loading: false,
          result: deserializeExtendBooking(action.data.extendBooking),
        },
      };
    // EXTEND BOOKING
    case CPM_DECLARE_FINAL_EXIT_FOR_BOOKING:
      return {
        ...state,
        declareFinalExit: {
          ...state.declareFinalExit,
          error: null,
          loading: true,
          result: null,
        },
      };

    case `${CPM_DECLARE_FINAL_EXIT_FOR_BOOKING}_ERROR`:
      return {
        ...state,
        declareFinalExit: {
          ...state.declareFinalExit,
          error: action.error,
          loading: false,
        },
      };

    case `${CPM_DECLARE_FINAL_EXIT_FOR_BOOKING}_SUCCESS`:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          result: {
            ...state.myBooking.result,
            status: mParking.STATUS_LIST.FINISHED,
          },
        },
        declareFinalExit: {
          ...state.declareFinalExit,
          loading: false,
          result: true,
        },
      };
    // PAY BOOKING OVERSTAY
    case CPM_PAY_BOOKING_OVERSTAY:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: null,
          loading: true,
          result: null,
        },
        offer: {
          ...state.offer,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_PAY_BOOKING_OVERSTAY}_ERROR`:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: action.error,
          loading: false,
        },
        offer: {
          ...state.offer,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_PAY_BOOKING_OVERSTAY}_SUCCESS`:
      // eslint-disable-next-line no-case-declarations
      const { purchases } = deserializePayBookingOverstay(action.data.payBookingOverstay);
      // eslint-disable-next-line no-case-declarations
      const overstayPurchase = getBookingLastOverstayPurchase(purchases);
      return {
        ...state,
        purchase: {
          ...state.purchase,
          loading: false,
          result: overstayPurchase,
        },
        offer: {
          ...state.offer,
          loading: false,
          result: overstayPurchase.offers[0],
        },
      };
    // CANCEL BOOKING
    case CPM_CANCEL_MY_BOOKING:
      return {
        ...state,
        cancel: {
          ...state.cancel,
          cancelled: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_CANCEL_MY_BOOKING}_ERROR`:
      return {
        ...state,
        cancel: {
          ...state.cancel,
          error: action.error,
        },
      };
    case `${CPM_CANCEL_MY_BOOKING}_SUCCESS`:
      mutationResult = action.data.cancelMyBooking;
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          result: deserializeBooking(mutationResult),
        },
        cancel: {
          ...state.cancel,
          cancelled: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // CPM_DOWNLOAD_MY_INVOICE
    case CPM_DOWNLOAD_MY_INVOICE:
      return {
        ...state,
        downloadMyInvoice: {
          ...state.downloadMyInvoice,
          downloaded: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DOWNLOAD_MY_INVOICE}_ERROR`:
      return {
        ...state,
        downloadMyInvoice: {
          ...state.downloadMyInvoice,
          error: action.error,
        },
      };
    case `${CPM_DOWNLOAD_MY_INVOICE}_SUCCESS`:
      mutationResult = action.data.downloadMyInvoice;
      return {
        ...state,
        downloadMyInvoice: {
          ...state.downloadMyInvoice,
          downloaded: true,
          result: mutationResult.uri,
        },
      };
    case CPM_RESET_MY_INVOICE_DOWNLOAD_REQUEST:
      return {
        ...state,
        downloadMyInvoice: {
          ...state.downloadMyInvoice,
          downloaded: false,
          result: null,
        },
      };
    // CPM_GET_MY_BOOKING
    case CPM_GET_MY_BOOKING:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_GET_MY_BOOKING}_ERROR`:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_MY_BOOKING}_SUCCESS`:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          loading: false,
          result: deserializeBooking(action.data.getMyBooking),
        },
      };
    // CPM_GET_UPDATED_MY_BOOKING
    case CPM_GET_UPDATED_MY_BOOKING:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          updated: {
            ...state.myBooking.updated,
            error: null,
            loading: true,
            result: null,
          },
        },
      };
    case `${CPM_GET_UPDATED_MY_BOOKING}_ERROR`:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          updated: {
            ...state.myBooking.updated,
            error: action.error,
            loading: false,
            result: null,
          },
        },
      };
    case `${CPM_GET_UPDATED_MY_BOOKING}_SUCCESS`:
      return {
        ...state,
        myBooking: {
          ...state.myBooking,
          updated: {
            ...state.myBooking.updated,
            error: action.error,
            loading: false,
            result: deserializeBooking(action.data.getMyBooking),
          },
        },
      };
    // CPM_GET_OFFER
    case CPM_GET_OFFER:
      return {
        ...state,
        offer: {
          ...state.offer,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_GET_OFFER}_ERROR`:
      return {
        ...state,
        offer: {
          ...state.offer,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_OFFER}_SUCCESS`:
      return {
        ...state,
        offer: {
          ...state.offer,
          loading: false,
          result: deserializeOffer(action.data.getOffer),
        },
      };
    // GENERATE OFFER
    case CPM_SEARCH_CARPARK_BOOKING_OFFER:
      return {
        ...state,
        search: {
          ...state.search,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_SEARCH_CARPARK_BOOKING_OFFER}_ERROR`:
      return {
        ...state,
        search: {
          ...state.search,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_SEARCH_CARPARK_BOOKING_OFFER}_SUCCESS`:
      return {
        ...state,
        book: {
          ...state.book,
          error: null,
        },
        search: {
          ...state.search,
          loading: false,
          result: deserializeOffer(action.data.search),
        },
      };

      // GENERATE EXTENSION OFFER
    case CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER:
      return {
        ...state,
        book: {
          ...state.book,
          error: null,
        },
        searchBookingExtensionOffer: {
          ...state.searchBookingExtensionOffer,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER}_ERROR`:
      return {
        ...state,
        searchBookingExtensionOffer: {
          ...state.searchBookingExtensionOffer,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER}_SUCCESS`:
      return {
        ...state,
        searchBookingExtensionOffer: {
          ...state.searchBookingExtensionOffer,
          loading: false,
          result: deserializeOffer(action.data.searchBookingExtensionOffer),
        },
      };
    default:
      return state;
  }
};

export default cpmBooking;



// WEBPACK FOOTER //
// ./reducers/cpm/booking/booking.js